<template>
  <div class="container">
    <h1>AVISO DE PRIVACIDAD</h1>

    <p><em>Fecha de última actualización: 26 de Mayo de 2025</em></p>

    <br />

    <p>
      En geoint.mx (en adelante, “nosotros”, “nuestro”, “la plataforma”), nos comprometemos a proteger y respetar tu privacidad. El presente Aviso de Privacidad tiene como objetivo informarte sobre cómo recopilamos, utilizamos, almacenamos y protegemos la información personal que nos proporcionas al registrarte en nuestro sitio web, al utilizar nuestras aplicaciones móviles o cualquier otro de nuestros servicios. Este aviso está diseñado para que tomes decisiones informadas acerca de la información personal que compartes con nosotros.
    </p>

    <div v-for="(seccion, index) in secciones" :key="index" class="section">
      <h2>{{ seccion.titulo }}</h2>
      <p v-if="seccion.intro">{{ seccion.intro }}</p>
      <ul v-if="seccion.bullets && seccion.bullets.length">
        <li v-for="(punto, i) in seccion.bullets" :key="i" v-html="punto"></li>
      </ul>
      <p v-if="seccion.texto">{{ seccion.texto }}</p>
    </div>

    <footer>
      <p>Atentamente,</p>
      <p><strong>geoint.mx Team</strong></p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AvisoPrivacidad',
  data() {
    return {
      secciones: [
        {
          titulo: '1. Información que recopilamos',
          intro: 'Al registrarte en la plataforma o utilizar nuestras aplicaciones móviles, recopilamos los siguientes datos personales:',
          bullets: [
            '<strong>Información de registro:</strong> Nombre completo y correo electrónico. Esta información es esencial para la creación de tu cuenta y la gestión de tu acceso a la plataforma.',
            '<strong>Información opcional del perfil:</strong> Puedes optar por completar tu perfil con información adicional como biografía, intereses y otros campos permitidos. Esta información es voluntaria.',
            '<strong>Fotografía de perfil (opcional):</strong> Si decides subir una imagen, se utilizará únicamente para tu identificación dentro de la plataforma.',
            '<strong>Datos de geolocalización:</strong> Cuando usas nuestras aplicaciones móviles, recopilamos datos de ubicación GPS en tiempo real, únicamente mientras las aplicaciones están activas, con el fin de georreferenciar los datos que ingresas y permitir su representación en geovisualizadores espaciales diseñados para tales fines.'
          ]
        },
        {
          titulo: '2. ¿Cómo utilizamos tu información?',
          bullets: [
            '<strong>Gestión de la cuenta de usuario:</strong> Crear y gestionar tu cuenta, y enviarte comunicaciones necesarias relacionadas con el funcionamiento de la plataforma (por ejemplo, notificaciones de seguridad, actualizaciones, etc.).',
            '<strong>Interacción con otros usuarios:</strong> Mostrar tu información de perfil, si así lo decides, para facilitar la interacción y la identificación mutua entre usuarios.',
            '<strong>Mejora del servicio:</strong> Analizar de forma agregada el uso de la plataforma para mejorar su funcionalidad, diseño y experiencia de usuario. No utilizamos esta información para fines de marketing directo sin tu consentimiento.',
            '<strong>Georreferenciación de datos en aplicaciones móviles:</strong> Los datos de GPS se utilizan exclusivamente para ubicar espacialmente la información que el usuario captura y presentarla en mapas o interfaces visuales diseñadas para tal propósito. Estos datos no se usan para seguimiento o monitoreo personal, y su recolección está limitada al uso activo de la aplicación.'
          ]
        },
        {
          titulo: '3. ¿Con quién compartimos tu información?',
          intro: 'Nos comprometemos a no compartir, vender ni alquilar tu información personal a terceros con fines comerciales. Sin embargo, es posible que compartamos tu información en los siguientes casos:',
          bullets: [
            '<strong>Con proveedores de servicios:</strong> Podemos compartir tu información con proveedores de servicios externos que nos asisten en la operación de nuestra plataforma (por ejemplo, servicios de alojamiento web, análisis de datos, etc.). Estos proveedores están obligados por contrato a proteger tu información de acuerdo con este aviso de privacidad.',
            '<strong>Por requerimiento legal:</strong> Si la ley lo exige, podemos compartir tu información para cumplir con procesos legales o en respuesta a una solicitud de una autoridad competente.'
          ]
        },
        {
          titulo: '4. Seguridad de la información',
          texto: 'Implementamos medidas técnicas y organizativas adecuadas para proteger la información personal que recopilamos. Estas medidas incluyen el uso de cifrado, protocolos de seguridad y acceso restringido a los datos personales dentro de la plataforma. Sin embargo, debes tener en cuenta que ninguna transmisión de datos a través de Internet es completamente segura y, aunque nos esforzamos por proteger tu información, no podemos garantizar la seguridad total de los datos que nos envíes.'
        },
        {
          titulo: '5. Tus derechos sobre tu información personal',
          bullets: [
            '<strong>Acceso:</strong> Puedes solicitar una copia de la información personal que hemos recopilado sobre ti.',
            '<strong>Corrección:</strong> Puedes corregir cualquier error o actualizar los datos que hemos almacenado.',
            '<strong>Eliminación:</strong> Puedes solicitar la eliminación de tu cuenta y la información personal asociada en cualquier momento. Sin embargo, algunos datos pueden ser retenidos para fines legales o de cumplimiento.',
            '<strong>Oposición al uso de tus datos:</strong> Puedes revocar tu consentimiento o modificar tus preferencias sobre el uso de ciertos datos en la configuración de tu cuenta o contactándonos directamente.'
          ]
        },
        {
          titulo: '6. Retención de datos',
          texto: 'Conservamos tu información personal solo durante el tiempo necesario para cumplir con los fines para los cuales fue recopilada, incluyendo el cumplimiento de cualquier obligación legal, contable o de reporte. En el caso de los datos de geolocalización, estos pueden ser almacenados junto con los datos que el usuario haya capturado para referencia espacial, y se conservarán únicamente mientras la información asociada siga siendo útil para los fines de la plataforma. Una vez que tu cuenta sea eliminada o desactivada, tus datos personales serán eliminados o anonimizados de acuerdo con nuestras políticas internas.'
        },
        {
          titulo: '7. Transferencias internacionales de datos',
          texto: 'En el caso de que tus datos sean transferidos fuera de tu país de residencia, tomaremos las medidas necesarias para garantizar que tu información personal reciba el mismo nivel de protección que si estuviera dentro de tu país. Esto puede incluir el uso de cláusulas contractuales estándar o mecanismos de cumplimiento con las leyes de protección de datos aplicables.'
        },
        {
          titulo: '8. Modificaciones al aviso de privacidad',
          texto: 'Nos reservamos el derecho de actualizar este Aviso de Privacidad en cualquier momento. Cuando lo hagamos, publicaremos la versión actualizada en esta página y te informaremos de los cambios significativos, si es necesario, por correo electrónico. Te recomendamos revisar periódicamente este aviso para estar al tanto de cualquier actualización.'
        },
        {
          titulo: '9. Contacto',
          texto: 'Si tienes alguna pregunta o inquietud sobre cómo manejamos tu información personal, incluidos los datos de geolocalización, o sobre este Aviso de Privacidad, no dudes en ponerte en contacto con nosotros.'
        },
        {
          titulo: '10. Aceptación del Aviso de Privacidad',
          texto: 'Al registrarte en "la plataforma", al utilizar nuestras aplicaciones móviles y al proporcionar tu información personal, aceptas los términos y condiciones establecidos en este Aviso de Privacidad. Si no estás de acuerdo con alguno de los términos, te invitamos a no proporcionar tu información personal y a no utilizar la plataforma.'
        }
      ]
    };
  }
};
</script>

<style scoped>
.container {
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
  background-color: #fff;
  font-family: 'Arial', sans-serif;
  color: #333;
  line-height: 1.6;
  text-align: justify;
}
h1 {
  color: #004080;
  margin-bottom: 20px;
  text-align: left;
}
h2 {
  margin-top: 30px;
  color: #004080;
  text-align: left;
}
ul {
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 10px;
}
li {
  margin-bottom: 10px;
}
footer {
  margin-top: 50px;
  font-size: 0.9em;
  color: #777;
}
</style>
